<template>
  <div id="star-currency">
    <h3 class="user-title">星币</h3>
    <div class="top">
      <p class="top-text"><span>4</span> 次呼叫老师的机会</p>
      <div class="top-btn">
        <div class="star-count">
          <img src="@/assets/images/star_img.png" alt="star_img"/>
          <span>余额：</span>
          <span class="money">45</span>
        </div>
        <router-link tag="div" class="star-info-btn" to="/user/stardetails">查看明细</router-link>
      </div>
    </div>
    <star-get></star-get>
    <div class="bottom">
      <h4>星币规则：</h4>
      <p>1.呼叫一次需要 10个星币 （ 10分钟内算1次，超过10分钟需要再使用1次机会，依次累计。）</p>
      <p>2.分享作品到好友或朋友圈可奖励星币。1个游戏关卡只能奖励1次。</p>
      <p>3.星币一旦购买不可退、不可兑现，购买课程可做现金抵扣。</p>
      <p>4.解释权归北京极客晨星。</p>
    </div>
  </div>
</template>

<script>
import StarGet from "./StarGet"
export default {
  name: "StarCurrency",
  components: {
    StarGet
  },
  methods: {
    showDetailHandler () {
      this.$router.push('/stardetails');
    }
  }
};
</script>

<style lang="scss" scoped>
#star-currency{
  padding-top: 10px;
  color: #606266;
  font-size: 14px;
  position: relative;
  .user-title{
    color: #fff;
    font-size: 21px;
    position: absolute;
    left: 47%;
    top: -64px;
  }
  .top{
    width: 100%;
    height: 100px;
    border-radius: 11px;
    background-color: #fff;
    font-size: 18px;
    .top-text{
      color: #595959;
      padding: 20px 35px 15px;
      span{
        color: #E9A400;
        font-size: 24px;
      }
    }
    .top-btn{
      display: flex;
      justify-content: space-between;
      padding: 0 35px;
      .star-count{
        img{
          width: 22px;
          margin: 5px 8px 0 0;
        }
        .money{
          color: #E9A400;
          font-size: 24px;
        }
      }
      .star-info-btn{
        width: 100px;
        height: 36px;
        line-height: 36px;
        color: #fff;
        border-radius: 20px;
        text-align: center;
        font-size: 16px;
        background-color: #F1B934;
        cursor: pointer;
        &:hover{
          background-color: #e44b19;
        }
      }
    }
  }
  .bottom{
    margin: 20px;
    h4{
      color: #2D2D2D;
      font-size: 14px;
      margin-bottom: 10px;
    }
    p{
      font-size: 12px;
      line-height: 20px;
    }
  }
}
</style>

